import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import MainContent from './components/MainContent';
import Footer from './components/Footer';
import Login from './pages/Login';
import Register from './pages/Register';
import AGB from './pages/AGB';
import Datenschutz from './pages/Datenschutz';
import DatenschutzApp from './pages/DatenschutzApp';
import Impressum from './pages/Impressum';
import Contact from './pages/Contact';
import RegistrationSuccess from './pages/RegistrationSuccess';
import DashboardLayout from './pages/DashboardLayout';
import DashboardHome from './pages/DashboardHome';
import Inbox from './pages/Inbox';
import CreateUser from './pages/CreateUser';
import UserCreationSuccess from './pages/UserCreationSuccess';
import ManageUsers from './pages/ManageUsers';
import EditUser from './pages/EditUser';
import ChangePassword from './pages/ChangePassword';
import ManageParticipants from "./pages/ManageParticipants";
import ParticipantForm from "./pages/ParticipantForm";
import ParticipantInfoPage from './pages/ParticipantInfoPage';
import AdminParticipantPage from './pages/AdminParticipantPage';
import ManageNotificationsAdmin from './pages/ManageNotificationsAdmin';
import CreateNotificationAdmin from './pages/CreateNotificationAdmin';
import EditNotificationAdmin from './pages/EditNotificationAdmin';
import ManageNotificationsUsers from './pages/ManageNotificationsUsers';
import CreateNotificationUser from './pages/CreateNotificationUser';
import EditNotificationUser from './pages/EditNotificationUser';
import Profile from './pages/Profile';
import ManageSessions from './pages/ManageSessions';
import CreateSession from './pages/CreateSession';
import EditSession from './pages/EditSession';
import AiTesting from './pages/AiTesting';


import './App.css';


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = localStorage.getItem('isAuthenticated');
    const user = localStorage.getItem('currentUser');
    const role = localStorage.getItem('userRole');

    if (auth) {
      setIsAuthenticated(true);
      setUserRole(role);
      setCurrentUser(user ? JSON.parse(user) : null);
    }
    setLoading(false);
  }, []);
  if (loading) return <p>Loading...</p>;

  // Protected route wrapper
  const ProtectedRoute = ({ children, allowedRoles }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }
    
    if (allowedRoles && !allowedRoles.includes(userRole)) {
      return <Navigate to="/unauthorized" replace />;
    }
    
    return children;
  };

  // Public routes (accessible without authentication)
  const publicRoutes = (
    <>
      <Route path="/" element={<MainContent />} />
      <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} setUserRole={setUserRole} setCurrentUser={setCurrentUser} />} />
      <Route path="/register" element={<Register />} />
      <Route path="/agb" element={<AGB />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/datenschutzapp" element={<DatenschutzApp />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/kontakt" element={<Contact />} />
      <Route path="/registration-success" element={<RegistrationSuccess />} />
    </>
  );

  // Admin-only routes
  const adminRoutes = (
    <>
      <Route element={<DashboardLayout />}>
        <Route path="inbox" element={<Inbox />} />

        <Route path="dashboard" element={<DashboardHome />} />

        <Route path="dashboard/users" element={<ManageUsers />} />
        <Route path="dashboard/participants" element={<ManageParticipants />} />
        <Route path="dashboard/participants-data" element={<AdminParticipantPage />} />
        
        <Route path="dashboard/notifications" element={<ManageNotificationsAdmin />} />
        <Route path="dashboard/notifications/new" element={<CreateNotificationAdmin />} />
        <Route path="dashboard/notifications/:id/edit" element={<EditNotificationAdmin />} />

        <Route path="dashboard/sessions" element={<ManageSessions />} />
        <Route path="dashboard/sessions/new" element={<CreateSession />} />
        <Route path="dashboard/sessions/edit/:sessionId" element={<EditSession />} />
        

        <Route path="dashboard/users/create" element={<CreateUser />} />
        <Route path="dashboard/users/edit/:id" element={<EditUser />} />
        <Route path="dashboard/users/user-creation-success" element={<UserCreationSuccess />} />
        {/* <Route path="/users/:id/change-password" element={<ChangePassword />} /> */}
        <Route path="dashboard/users/change-password/:id" element={<ChangePassword />} />
        
        <Route path="dashboard/participants/new" element={<ParticipantForm />} />
        <Route path="dashboard/participants/:id/edit" element={<ParticipantForm />} />

        <Route path="dashboard/ai-test" element={<AiTesting />} />

      </Route>

      <Route path="/create-user" element={
        <ProtectedRoute allowedRoles={['admin']}>
          <CreateUser />
        </ProtectedRoute>
      } />
      <Route path="/user-creation-success" element={
        <ProtectedRoute allowedRoles={['admin']}>
          <UserCreationSuccess />
        </ProtectedRoute>
      } />
      
      <Route path="/manage-users" element={
        <ProtectedRoute allowedRoles={['admin']}>
          <ManageUsers />
        </ProtectedRoute>
      } />
      <Route path="/edit-user/:id" element={
        <ProtectedRoute allowedRoles={['admin']}>
          <EditUser />
        </ProtectedRoute>
      } />
      <Route path="/edit-user/:id" element={
        <ProtectedRoute allowedRoles={['admin']}>
          <ChangePassword />
        </ProtectedRoute>
      } />
      <Route path="/participants" element={
        <ProtectedRoute allowedRoles={['admin']}>
          <ManageParticipants />
        </ProtectedRoute>
      } />
      <Route path="/participants/new" element={
        <ProtectedRoute allowedRoles={['admin']}>
          <ParticipantForm />
        </ProtectedRoute>
      } />
      <Route path="/participants/:id/edit" element={
        <ProtectedRoute allowedRoles={['admin']}>
          <ParticipantForm />
        </ProtectedRoute>
      } />

      <Route 
        path="/participants-page" 
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminParticipantPage />
          </ProtectedRoute>
        } 
      />

    </>
  );

  const userRoutes = (
    <>
      <Route path="/participant-info" element={
        <ProtectedRoute allowedRoles={['parent', 'teacher', 'admin']}>
          <ParticipantInfoPage />
        </ProtectedRoute>
      } />

      <Route path="/my-notifications" element={
        <ProtectedRoute allowedRoles={['parent', 'teacher', 'admin']}>
          <ManageNotificationsUsers />
        </ProtectedRoute>
      } />

      <Route path="my-notifications/new" element={
        <ProtectedRoute allowedRoles={['parent', 'teacher', 'admin']}>
          <CreateNotificationUser />
        </ProtectedRoute>
      } />

      <Route path="my-notifications/:id/edit" element={
        <ProtectedRoute allowedRoles={['parent', 'teacher', 'admin']}>
          <EditNotificationUser />
        </ProtectedRoute>
      } />

      <Route path="/profile" element={
        <ProtectedRoute allowedRoles={['parent', 'teacher', 'admin']}>
          <Profile />
        </ProtectedRoute>
      } />


    </>
  );

  // Fallback routes
  const fallbackRoutes = (
    <>
      <Route path="/unauthorized" element={<div>Unauthorized access</div>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </>
  );

  return (
    <div className="app">
      <Header 
        isAuthenticated={isAuthenticated}
        currentUser={currentUser}
        onLogout={() => {
          setIsAuthenticated(false);
          setCurrentUser(null);
          setUserRole(null);
          localStorage.removeItem('isAuthenticated');
          localStorage.removeItem('userRole');
          localStorage.removeItem('currentUser');
        }} 
      />
      
      <Routes>
        {publicRoutes}
        {isAuthenticated && userRole === 'admin' && adminRoutes}
        {isAuthenticated && (userRole === 'parent' || userRole === 'teacher') && userRoutes}
        {fallbackRoutes}
      </Routes>
      
      <Footer />
    </div>
  );
}

export default App;